import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import { get } from 'lodash';

import { Breadcrumbs, Typography } from '@mui/material';
import Schema from '../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const BreadCrumbAbschlussbericht: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ maxWidth: '81.875rem'}}>
				<Typography color="secondary">Mein Bereich</Typography>
				<Typography color="secondary">Förderungen</Typography>
				<Typography color="secondary">Abschlussbericht</Typography>
				<Typography color="primary">
					{get(application, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '*')}
				</Typography>
			</Breadcrumbs>
		</>
	);
};

export default BreadCrumbAbschlussbericht;
